@if (conciergeEnabled) {
  <div class="tw-mb-4 tw-flex tw-items-baseline tw-justify-between tw-gap-3">
    <p id="guest-requests-widget-title" class="tw-m-0 tw-flex tw-min-w-0 tw-flex-1 tw-items-center" [mhTooltip]="'dashboard.service_requests.tooltip' | translate: { conciergeName: conciergeSettings?.name }" position="above">
      <span class="tw-font-medium tw-text-base">{{ 'dashboard.service_requests.title_main' | translate }}</span>
      <span class="tw-ml-1 tw-text-gray-400 tw-text-base tw-font-medium">
        {{ 'dashboard.service_requests.title_secondary' | translate }}
      </span>
    </p>
    @if (paginationData) {
      <span class="tw-shrink-0 tw-whitespace-nowrap tw-text-sm tw-font-medium" [mhTooltip]="'dashboard.service_requests.counter_tooltip' | translate"  position="left">
        {{
          'dashboard.service_requests.counter'
            | translate: { current: paginationData?.finished_tasks, total: paginationData?.total_of_elements }
        }}
      </span>
      <mh-core-lib-actions-wrapper
        slug="service_request_config"
      >
        <span (click)="goToSettings()" [mhTooltip]="'dashboard.service_requests.settings_tooltip' | translate" position="left">
          <i class="far fa-cog tw-text-gray-500 tw-cursor-pointer"></i>
        </span>
      </mh-core-lib-actions-wrapper>
    }
  </div>

  @if (initialLoading && tasks.length === 0) {
    <div class="tw-flex tw-justify-center tw-py-6">
      <mh-core-lib-loader-wrapper
        [type]="'spinner'"
        [loading]="true"
        [spinnerClassName]="'tw-text-2xl tw-text-gray-400'"
      >
      </mh-core-lib-loader-wrapper>
    </div>
  } @else {
    @if (tasks.length === 0) {
      <div class="tw-flex tw-flex-col tw-h-full">
        <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-4">
          <p class="tw-text-[26px] tw-font-semibold tw-leading-none tw-text-gray-300 tw-text-center">
            {{ 'dashboard.service_requests.no_tasks' | translate }}
          </p>
        </div>
      </div>
    }

    <div class="tw-relative">
      @if (initialLoading) {
        <div
          class="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-white/60 tw-backdrop-blur-[1px]"
        >
          <mh-core-lib-loader-wrapper
            [type]="'spinner'"
            [loading]="true"
            [spinnerClassName]="'tw-text-2xl tw-text-gray-400'"
          >
          </mh-core-lib-loader-wrapper>
        </div>
      }
      <div
        class="tw-flex tw-flex-col tw-gap-3 tw-overflow-y-auto tw-max-h-[calc(100vh-20rem)] tw-pr-1"
        (scroll)="onScroll($event)"
      >
        @for (task of tasks; track task.id) {
          <article
            class="tw-flex tw-min-h-20 tw-shrink-0 tw-items-start tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-0"
          >
            <div
              class="tw-w-2 tw-shrink-0 tw-self-stretch"
              [ngClass]="{
                'tw-bg-red-500': task.status_name === 'PENDING',
                'tw-bg-yellow-400': task.status_name === 'IN_PROGRESS',
                'tw-bg-green-500': task.status_name === 'FINISHED',
              }"
              aria-hidden="true"
            ></div>
            <div
              class="tw-min-w-0 tw-flex-1 tw-py-2 tw-pl-3 tw-cursor-pointer"
              (click)="handleCardClick(task)"
              [ngClass]="(task.category_name && task.status_name !== 'FINISHED') ? 'tw-pr-2' : 'tw-pr-3.5'"
              [mhTooltip]="'dashboard.service_requests.go_to_conversation' | translate"
              [width]="'tw-w-fit'"
            >
              <p
                class="tw-m-0 tw-mb-0.5 tw-text-sm tw-font-semibold tw-leading-tight first-letter:tw-uppercase"
                [ngClass]="
                  task.category_name !== 'Talk_to_human' ||
                  (task.category_name === 'Talk_to_human' && task.in_free_window)
                    ? 'tw-text-gray-900'
                    : 'tw-text-gray-400'
                "
              >
                {{ task?.tracking_number }} - {{ task.description || '-' }}
              </p>
              <p
                class="tw-m-0 tw-mb-1 tw-text-xs tw-font-normal tw-leading-snug"
                [ngClass]="
                  task.category_name !== 'Talk_to_human' ||
                  (task.category_name === 'Talk_to_human' && task.in_free_window)
                    ? 'tw-text-gray-900'
                    : 'tw-text-gray-400'
                "
              >
                @if (task.guest_name && task.guest_room) {
                  {{ task.guest_name }} - {{ task.guest_room }}
                } @else {
                  {{ task.external_line }}
                }
              </p>
              <p class="tw-m-0 tw-mt-1 tw-text-[11px] tw-leading-snug tw-text-gray-400 tw-font-medium">
                {{ 'dashboard.service_requests.' + task.status_name | translate }}
              </p>
              <p class="tw-m-0 tw-text-[11px] tw-leading-snug tw-text-gray-400 tw-font-medium">
                {{
                  'dashboard.service_requests.created_at' | translate: { date: task.created_at | utcToLocalTime: 'dd-MM-yyyy', time: task.created_at | utcToLocalTime: 'HH:mm' }
                }}
              </p>
            </div>
            @if (task.category_name && task.status_name !== 'FINISHED') {
              <button
                type="button"
                class="tw-m-0 tw-mr-3.5 tw-shrink-0 tw-self-center tw-whitespace-nowrap tw-rounded-full tw-border tw-border-sky-600 tw-bg-transparent tw-px-4 tw-py-2 tw-text-sm tw-leading-tight tw-text-sky-600 tw-cursor-default focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-sky-600 focus:tw-ring-offset-2 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
                (click)="handleActionClick(task)"
                [disabled]="task.updating"
              >
                @if (task.updating) {
                  <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-min">
                    <mh-core-lib-loader-wrapper
                      [type]="'spinner'"
                      [loading]="true"
                      [spinnerClassName]="'tw-text-base tw-text-sky-600'"
                    >
                    </mh-core-lib-loader-wrapper>
                  </span>
                } @else {
                  {{
                    'dashboard.service_requests.' + (task.status_name === 'PENDING' ? 'take_task' : 'complete_task')
                      | translate
                  }}
                }
              </button>
            }
          </article>
        }

        @if (loadingMore) {
          <div class="tw-flex tw-justify-center tw-py-3">
            <mh-core-lib-loader-wrapper
              [type]="'spinner'"
              [loading]="true"
              [spinnerClassName]="'tw-text-xl tw-text-gray-400'"
            >
            </mh-core-lib-loader-wrapper>
          </div>
        }
      </div>
    </div>
  }
} @else {
  <div class="tw-flex tw-flex-col tw-h-full">
    <p id="guest-requests-widget-title" class="tw-m-0 tw-flex tw-min-w-0 tw-items-center">
      <span class="tw-font-medium tw-text-base">{{ 'dashboard.service_requests.title_main' | translate }}</span>
      <span class="tw-ml-1 tw-text-gray-400 tw-text-base tw-font-medium">
        {{ 'dashboard.service_requests.title_secondary' | translate }}
      </span>
    </p>

    <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-4">
      <p class="tw-text-[26px] tw-font-semibold tw-leading-none tw-text-gray-300 tw-text-center">
        {{ 'dashboard.service_requests.disabled_message' | translate }}
      </p>
    </div>

    <div class="tw-flex tw-justify-center tw-pb-2">
      <mh-core-lib-button
        [isSecondary]="true"
        [width]="265"
        [height]="38"
        customClass="!tw-rounded-full !tw-font-[Rubik]"
        textClass="tw-font-semibold"
        [text]="'dashboard.service_requests.know_more_concierge' | translate"
        (clicked)="goToConciergePlg()"
      >
      </mh-core-lib-button>
    </div>
  </div>
}
